export const ExternalHwSignUp = (externalWebsite: string) => {
    return `${externalWebsite}/home-warranty`
}
